import { render, staticRenderFns } from "./NotificationPopupSuccessTransaction.vue?vue&type=template&id=e23a16f0&scoped=true&lang=pug"
import script from "./NotificationPopupSuccessTransaction.vue?vue&type=script&lang=ts"
export * from "./NotificationPopupSuccessTransaction.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPopupSuccessTransaction.vue?vue&type=style&index=0&id=e23a16f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23a16f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VIcon,VImg})
